const approval = require('./approval');
const accountName = require('./account-name');
const eventUsers = require('./event-users');
const emsStatus = require('./ems-status');
const boolean = require('./boolean');
const catering = require('./catering');
const cateringDietaryRestrictions = require('./catering_dietary_restrictions');
const credentials = require('./credentials');
const date = require('./date');
const datetime = require('./datetime');
const dropdown = require('./dropdown');
const dependency = require('./dependency');
const eventDays = require('./event-days');
const multipleSelect = require('./multiple_select');
const number = require('./number');
const text = require('./text');
const time = require('./time');
const user = require('./user');
const file = require('./file');
const staticValue = require('./static');
const phone = require('./phone');
const countries = require('./countries');
const inventoryList = require('./inventory-list');
const inventory = require('./inventory');
const reference = require('./reference');
const source = require('./source');
const lookup = require('./lookup');
const catalogItem = require('./catalog-item');
const eventList = require('./event-list');
const accountList = require('./account-list');
const primaryContacts = require('./primary-contacts');
const form = require('./form');
const documentRequest = require('./document-request');
const payment = require('./payment');
const itemGroup = require('./item-group');
const itemBlock = require('./item-block');
const allocatedItems = require('./allocated-items');
const schedule = require('./schedule');
const peopleBlock = require('./people-block');
const signature = require('./signature');
const hasPortalAccess = require('./has-portal-access');
const zone = require('./zone');
const healthPass = require('./health-pass');

module.exports = function (value, type) {
  switch (type) {
    case 'checkbox':
    case 'boolean':
      return boolean(value);
    case 'approval':
      return approval(value);
    case 'catering_dietary_restrictions':
      return cateringDietaryRestrictions(value);
    case 'catering':
      return catering(value);
    case 'credentials':
      return credentials(value);
    case 'catalog-item':
      return catalogItem(value);
    case 'date':
      return date(value);
    case 'datetime':
      return datetime(value);
    case 'dropdown':
      return dropdown(value);
    case 'dependency':
      return dependency(value);
    case 'event-days':
      return eventDays(value);
    case 'multiple_select':
      return multipleSelect(value);
    case 'number':
    case 'quantity':
    case 'percent':
    case 'currency':
      return number(value);
    case 'contact':
    case 'textarea':
    case 'status':
    case 'email':
    case 'text':
      return text(value);
    case 'time':
      return time(value);
    case 'user':
      return user(value);
    case 'file':
      return file(value);
    case 'static':
      return staticValue(value);
    case 'source':
      return source(value);
    case 'phone':
      return phone(value);
    case 'countries':
      return countries(value);
    case 'inventory-list':
      return inventoryList(value);
    case 'inventory':
      return inventory(value);
    case 'reference':
      return reference(value);
    case 'lookup':
      return lookup(value);
    case 'account-list':
      return accountList(value);
    case 'event-list':
      return eventList(value);
    case 'primary-contacts':
      return primaryContacts(value);
    case 'document-request':
      return documentRequest(value);
    case 'health-pass':
      return healthPass(value);
    case 'form':
      return form(value);
    case 'payment':
      return payment(value);
    case 'item-group':
      return itemGroup(value);
    case 'item-block':
      return itemBlock(value);
    case 'allocated-items':
    case 'allocated-passes':
    case 'allocated-meals':
      return allocatedItems(value);
    case 'schedule':
      return schedule(value);
    case 'people-block':
      return peopleBlock(value);
    case 'event-users':
      return eventUsers(value);
    case 'ems-status':
      return emsStatus(value);
    case 'has-portal-access':
      return hasPortalAccess(value);
    case 'account-name':
    case 'contact-name':
    case 'event-name':
      return accountName(value);
    case 'signature':
      return signature(value);
    case 'zone':
      return zone(value);
    default:
    // @NOTE: Uncomment to debug
    // console.log(`No handler defined for ${type}`);
  }
};
